var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageButtonTg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 58,
    height: 58,
    fill: "#0593F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 58,
    height: 58,
    stroke: "#00041A",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.271 15.2104C44.7136 15.0241 45.1981 14.9598 45.674 15.0243C46.1499 15.0888 46.5998 15.2797 46.9769 15.577C47.354 15.8744 47.6445 16.2674 47.8182 16.7151C47.9918 17.1628 48.0423 17.6489 47.9644 18.1228L43.902 42.7637C43.508 45.1406 40.9001 46.5036 38.7202 45.3197C36.8968 44.3292 34.1886 42.8031 31.7526 41.2108C30.5347 40.4137 26.8037 37.8613 27.2622 36.0451C27.6563 34.4922 33.9253 28.6566 37.5076 25.1871C38.9137 23.8241 38.2724 23.0377 36.612 24.2915C32.4888 27.4046 25.8687 32.1386 23.6799 33.4712C21.749 34.6462 20.7424 34.8468 19.5388 34.6462C17.3428 34.2808 15.3063 33.7148 13.6441 33.0252C11.398 32.0938 11.5072 29.0059 13.6423 28.1067L44.271 15.2104Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageButtonTg);
export default __webpack_public_path__ + "static/media/message-button-tg.201e4411a37bf6e69c8da20a1ae41760.svg";
export { ForwardRef as ReactComponent };